module.exports = __webpack_public_path__ + "static/media/romanian_potez63.69a1b039.png";